import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pregunta } from '../../models/pregunta.model';

@Component({
  selector: 'app-scale',
  templateUrl: './scale.component.html',
  styleUrl: './scale.component.scss'
})
export class ScaleComponent {

  @Input() pregunta?: Pregunta;
  @Input() scaleValue?: number;
  @Output() scaleValueChange = new EventEmitter<number>();

  public range = Array.from({ length: 11 }, (_, i) => i);

  onScaleChange(value: number) {
    this.scaleValue = value;
    this.scaleValueChange.emit(value);
  }

}
